import { call, put, takeLatest } from "redux-saga/effects"

//restapi end point
import * as constClass from "../../../common/constant/constantURL"
// Login Redux States
import { COMPANY_STATUS, DELETE_ORGANIZATION, DOWNLOAD, GET_COMPANY_DETAIL, GET_ONE_COMPANY_DETAIL, NEW_COMPANY_ADD } from "./actionTypes"
import {
  addNewComapnyError, addNewComapnySuccess,
  companyStatusError,
  companyStatusSuccess,
  deleteOrganizationFail,
  deleteOrganizationSuccess,
  downloadError,
  downloadSuccess,
  getCompanyDetailsError,
  getCompanyDetailsSuccess,
  getOneCompanyDetailsError,
  getOneCompanyDetailsSuccess
} from "./actions"


import { deleteCall, getRequest, postCall, putCall } from "../../../helpers/fakebackend_helper"

function* companyDetails(data) {
    try 
    {
      let url = constClass.REST_API_GET_RECRUITER_CLIENTS
      if(data.payload !== undefined && data.payload !== null){
        url = url+data.payload
      }
      else{
        url = url+"/name"
      }
      let responseJSON = yield call(getRequest,url );
      yield put(getCompanyDetailsSuccess(responseJSON))
    } 
    catch (error) 
    {
      yield put(getCompanyDetailsError(error))
    }
  }

  function* addCompany(data) {
    try 
    {  
      if (data.payload.id !==null && data.payload.id !== undefined && data.payload.id !==""){
        let responseJSON = yield call(putCall, constClass.REST_API_GET_RECRUITER_CLIENTS,data.payload);
        yield put(addNewComapnySuccess(responseJSON))
      }
      else{
        let responseJSON = yield call(postCall, constClass.REST_API_GET_RECRUITER_CLIENTS,data.payload);
        yield put(addNewComapnySuccess(responseJSON))
      }
      
    } 
    catch (error) 
    {
      yield put(addNewComapnyError(error))
    }
  }

  function* companyChangeStatus(data) {
    try 
    {  
      let responseJSON = yield call(getRequest, constClass.REST_API_GET_RECRUITER_CLIENTS_STATUS+data.payload);
      yield put(companyStatusSuccess(responseJSON))
    } 
    catch (error) 
    {
      yield put(companyStatusError(error))
    }
  }

  function* getCompanyDetailHandler(data){
    try{
      let responseJSON = yield call(getRequest, constClass.REST_API_GET_ONE_COMPANY_DETAILS+data.payload);
      yield put(getOneCompanyDetailsSuccess(responseJSON))
    }
    catch(error){
      yield put(getOneCompanyDetailsError(error))
    }
  }
  
  function* download(data) {
    try 
    {
      let url = constClass.REST_API_GET_RECRUITER_CLIENTS_DOWNLOAD
      if(data.payload !== undefined && data.payload !== null){
        url = url+data.payload
      }
      let responseJSON = yield call(getRequest, url);
      yield put(downloadSuccess(responseJSON))
    } 
    catch (error) 
    {
      yield put(downloadError(error))
    }
  }

  function* deleteOrganizationHadler(data) {
    try 
    {
      let url = constClass.REST_API_GET_RECRUITER_CLIENTS
      url = url+`/${data?.payload}`
      let responseJSON = yield call(deleteCall, url);
      yield put(deleteOrganizationSuccess(responseJSON))
    } 
    catch (error) 
    {
      yield put(deleteOrganizationFail(error))
    }
  }

function* myCompanySaga() {
  yield takeLatest(GET_COMPANY_DETAIL, companyDetails)
  yield takeLatest(NEW_COMPANY_ADD, addCompany)
  yield takeLatest(COMPANY_STATUS, companyChangeStatus)
  yield takeLatest(GET_ONE_COMPANY_DETAIL,getCompanyDetailHandler)
  yield takeLatest(DOWNLOAD,download)
  yield takeLatest(DELETE_ORGANIZATION, deleteOrganizationHadler)
}

export default myCompanySaga
